module.exports = __webpack_public_path__ + "static/media/hemlig.7c16588f.mp3";